import { useEffect, useState } from "react";
import { useFavorites } from "@/hooks/useFavorites";

interface DetailActionsProps {
  movieId: string;
  title: string;
}

export default function DetailActions({ movieId, title }: DetailActionsProps) {
  const { toggle, isFavorite } = useFavorites();
  const [toast, setToast] = useState("");

  useEffect(() => {
    if (!toast) return;
    const timer = window.setTimeout(() => setToast(""), 2200);
    return () => window.clearTimeout(timer);
  }, [toast]);

  const favorited = isFavorite(movieId);

  const handleFavorite = () => {
    toggle(movieId);
    setToast(favorited ? "已取消收藏" : "已加入收藏");
  };

  const handleShare = async (channel: string) => {
    if (channel === "链接") {
      try {
        await navigator.clipboard.writeText(`${window.location.href}`);
      } catch {
        // 忽略剪贴板异常
      }
      setToast("链接已复制，快去分享吧");
      return;
    }
    setToast(`已唤起${channel}分享（演示）`);
  };

  const shareChannels = [
    { label: "微信", icon: "ri-wechat-line" },
    { label: "微博", icon: "ri-weibo-line" },
    { label: "链接", icon: "ri-link" },
  ];

  return (
    <div className="relative">
      <div className="flex flex-wrap items-center gap-3">
        <button
          type="button"
          onClick={handleFavorite}
          className={`flex items-center gap-2 px-5 py-2.5 rounded-md text-sm whitespace-nowrap cursor-pointer transition-colors ${
            favorited
              ? "bg-accent-500 text-foreground-950"
              : "bg-primary-500 text-background-50 hover:bg-primary-600"
          }`}
        >
          <i className={favorited ? "ri-star-fill" : "ri-star-line"}></i>
          {favorited ? "已收藏" : "收藏"}
        </button>

        <span className="flex items-center gap-2 h-10 px-3 rounded-md border border-background-300">
          <span className="text-xs text-foreground-500 whitespace-nowrap">分享至</span>
          {shareChannels.map((channel) => (
            <button
              key={channel.label}
              type="button"
              aria-label={`分享到${channel.label}`}
              onClick={() => handleShare(channel.label)}
              className="w-7 h-7 flex items-center justify-center rounded-md text-foreground-600 cursor-pointer hover:bg-background-100 hover:text-primary-600 transition-colors"
            >
              <i className={`${channel.icon} text-lg`}></i>
            </button>
          ))}
        </span>
      </div>

      {toast && (
        <div className="fixed bottom-24 left-1/2 -translate-x-1/2 z-50 px-4 py-2.5 rounded-md bg-foreground-950/90 text-background-50 text-sm animate-fade-in whitespace-nowrap">
          {title} · {toast}
        </div>
      )}
    </div>
  );
}